import { gql } from '@efficiently/client-core-graphql-models';

export const CREATE_PLAN_WITH_UPLOAD = gql(`
	mutation CreatePlanWithUpload($args: CreatePlanWithUploadArgs!) {
		createPlanWithUpload(args: $args) {
			versionId
		}
	}
`);
